import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

export const useWindowSize = (callback: Function) => {
  const isClient = typeof window === 'object';

  const getSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }, [isClient]);

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return () => {};
    }

    const handleResize = _.debounce(() => {
      setWindowSize(getSize());
      callback();
    }, 200);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [callback, getSize, isClient]);

  return windowSize;
};

export default useWindowSize;
